import { DISPLAY_MODES, SEARCH_PARAM_DISPLAY_KEY } from "../constants";
import { LocationSource } from "../CoreApp/LocationSource";

export function isInTabularView(): boolean {
  return (
    new URLSearchParams(LocationSource.getSearch()).get(SEARCH_PARAM_DISPLAY_KEY) ===
    DISPLAY_MODES.TABLE
  );
}
